import {
  COMPONENT_VALUE_TYPES as types,
} from 'shared/constants';

const propsSchema = [
  {
    key: 'screen_size',
    label: 'Screen Size',
    type: types.OBJECT,
    children: [
      {
        key: 'default_visible',
        label: 'Default visible (0px - 399px)',
        type: types.BOOLEAN
      },
      {
        key: 'xs_visible',
        label: 'XS visible (400px - 599px)',
        type: types.BOOLEAN
      },
      {
        key: 'sm_visible',
        label: 'SM visible (600px - 899px)',
        type: types.BOOLEAN
      },
      {
        key: 'md_visible',
        label: 'MD visible (900px - 1199px)',
        type: types.BOOLEAN
      },
      {
        key: 'lg_visible',
        label: 'LG visible (1200px - 1535px)',
        type: types.BOOLEAN
      },
      {
        key: 'xl_visible',
        label: 'XL visible (>= 1536px)',
        type: types.BOOLEAN
      },
    ]
  },
];

const defaultProps = {
  screen_size: {
    default_visible: true,
    xs_visible: true,
    sm_visible: true,
    md_visible: true,
    lg_visible: true,
    xl_visible: true,
  }
};

export default {
  title: 'Responsive Display Container',
  id: 'ResponsiveDisplayContainer',
  widgetImage: '/widgetImages/Column.png',
  basic: true,
  propsSchema,
  defaultProps
};
